<template>
	<div class="field-group">
		<span class="input-label">{{ label }}</span>
		<slot></slot>
		<p class="input-help" v-if="help !== ''" v-html="help"></p>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		label: { default: "" },
		help: { default: "" },
	},
};
</script>
